export const SUPER_ADMIN_ONLY_INBOX_SETTING_TABS = [
  'configuration',
  'csat',
  'bot-configuration',
  'whatsapp-health',
];

export const isSuperAdminOnlyInboxSettingTab = tabKey =>
  SUPER_ADMIN_ONLY_INBOX_SETTING_TABS.includes(tabKey);

export const filterInboxSettingsTabsForUser = (tabs, currentUser = {}) => {
  if (currentUser?.type === 'SuperAdmin') return tabs;

  return tabs.filter(tab => !isSuperAdminOnlyInboxSettingTab(tab.key));
};
